import React, { useState } from "react";
import { Card, Tag, Collapse } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { FaRegBuilding, FaRegCalendarAlt } from "react-icons/fa";
import { BsHospital } from "react-icons/bs";

const { Panel } = Collapse;

// Format "09:00:00" → "09:00 AM"
const formatTime = (time) => {
    if (!time) return "";
    const [hourStr, minuteStr] = time.split(":");
    const hour = parseInt(hourStr, 10);
    const minute = minuteStr;
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${displayHour}:${minute} ${ampm}`;
};

const WorkingDayCard = ({ group, dayMap }) => {
    return (
        <Card
            title={
                <div className="flex items-center">
                    {group.isOwned
                        ? <FaRegBuilding className="mr-2 text-primary" />
                        : <BsHospital className="mr-2 text-secondary" />
                    }
                    {group.isOwned ? group.clinicName : `${group.clinicName} (Center)`}
                </div>
            }
            className="shadow-sm"
        >
            <div className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {group.days.map((day) => (
                        <div
                            key={day.id}
                            className={`rounded-md border ${
                                day.isWorking
                                    ? "bg-white border-gray-200"
                                    : "bg-gray-100 opacity-60 border-gray-300"
                            }`}
                        >
                            {/* Day header */}
                            <div className="flex items-center gap-2 px-3 py-2 border-b border-gray-100">
                                <FaRegCalendarAlt className="text-secondary" />
                                <span className={`font-medium text-sm ${!day.isWorking && "line-through text-gray-400"}`}>
                                    {dayMap[day.dayOfWeek]}
                                </span>
                                <Tag
                                    className="ml-auto text-xs"
                                    color={day.isWorking ? "green" : "default"}
                                >
                                    {day.isWorking ? "Active" : "Inactive"}
                                </Tag>
                            </div>

                            {/* Availability hours */}
                            <div className="px-3 py-2">
                                {day.availabilityHours?.length > 0 ? (
                                    <div className="space-y-1">
                                        <p className="text-xs text-gray-400 mb-1 flex items-center gap-1">
                                            <ClockCircleOutlined /> {day.availabilityHours.length} time slot{day.availabilityHours.length > 1 ? "s" : ""}
                                        </p>
                                        {day.availabilityHours.map((slot) => (
                                            <div
                                                key={slot.id}
                                                className="flex items-center justify-between bg-primary/10 border border-primary/40 rounded px-2 py-1 text-xs"
                                            >
                                                <span className="text-primary font-medium">
                                                    {formatTime(slot.startTime)} – {formatTime(slot.endTime)}
                                                </span>
                                                {slot.maxPatients != null && (
                                                    <span className="text-gray-500 ml-2">
                                                        Max: {slot.maxPatients}
                                                    </span>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <p className="text-xs text-gray-400 italic">No time slots</p>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default WorkingDayCard;